import React, { useMemo, Children } from 'react';

import {
  SimpleForm,
} from 'react-admin';

import {
  Box,
  Card,
  CardContent,
  Grid,
} from '@mui/material';

import { useParams } from 'react-router-dom';
import HorizontalLabelPositionBelowStepper from './Stepper';
import FormNavigationActions from './FormNavigationActions';
import isDefinedFilter from '../../../utilities/isDefinedFilter';

interface ChildrenProps {
  value: string;
  path: string;
  label?: string;
}

type Props = {
  children: React.ReactNode;
  exitTo: string;
};

const FormNavigation = ({
  children,
  exitTo,
}: Props) => {
  const { path } = useParams();

  const childrenArray = Children.toArray(children);

  const Child = useMemo(() => childrenArray.find((child) => {
    if (!React.isValidElement(child)) return false;
    return (child as React.ReactElement<ChildrenProps>).props.path === path;
  }), [childrenArray, path]);

  const steps = useMemo(() => childrenArray.map((child) => {
    if (!React.isValidElement(child)) return undefined;
    return (child as React.ReactElement<ChildrenProps>).props.path;
  }).filter(isDefinedFilter), [childrenArray]);

  return (
    <Box minHeight="100vh" sx={{ padding: { xs: 1, sm: 3 } }}>
      <SimpleForm mode="all" toolbar={false}>
        <Grid container spacing={3} justifyContent="center">
          <Grid
            size={{
              xs: 12,
              lg: 10,
            }}
          >
            <HorizontalLabelPositionBelowStepper steps={steps} />
          </Grid>
          <Grid
            size={{
              xs: 12,
              lg: 10,
            }}
          >
            <Card>
              <CardContent>
                <Box>
                  {Child}
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            size={{
              xs: 12,
              lg: 10,
            }}
          >
            <FormNavigationActions steps={steps} exitTo={exitTo} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Box>
  );
};

export default FormNavigation;
